import store from "../../../../store";
import email_forward_editor from './email_forward_editor.vue';


window.email_forward_editor =  new Vue({
    store,
    el: '#email_forward_editor',
    name : "email_forward_editor",
    created () {

    },
    components : {
        email_forward_editor
    }
})
